module.exports = __webpack_public_path__ + "img/ic_check_layer2.469a55f3.png";